import './App.css';
import React from 'react';
import dayjs from 'dayjs';

class App extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            date: undefined,
            type: undefined,
        };
    }

    editDate(date) {
        const { type } = this.state;
        if (!type) {
            return alert("Select an exposure type first");
        }
        let dayToAdd;
        switch (type) {
            case 'positive':
                dayToAdd = 11;
                break;
            case 'direct':
                dayToAdd = 15;
                break;
            case 'direct-7':
                dayToAdd = 8;
                break;
            case 'direct-10':
                dayToAdd = 11;
                break;
            case 'direct-24':
                dayToAdd = 25;
                break;
            default:
                break;
        }
        this.setState({ date: dayjs(date).add(dayToAdd, 'day').format('MM/DD/YYYY') })
    }

    handleType(type) {
        this.setState({ type, date: undefined });
    }

    render() {
        const { date, type } = this.state;
        return (
            <div className="app">
                <div style={{ marginBottom: 8}}>Exposure type</div>
                <select className="select-css" onChange={e => this.handleType(e.target.value)}>
                    <option value="">Select type</option>
                    <option value="positive">Positive test</option>
                    <option value="direct">Direct contact</option>
                    <option value="direct-7">Direct contact (7 days)</option>
                    <option value="direct-10">Direct contact (10 days)</option>
                    <option value="direct-24">Direct contact (24 days)</option>
                </select>
                {Boolean(type) &&
                    <div>
                        <div style={{marginTop: 20, marginBottom: 8}}>Date of exposure</div>
                        <input className="select-css" onChange={e => this.editDate(e.target.value)} type="date" />
                    </div>
                }
                {Boolean(date) &&
                    <div className="expires">
                        <div style={{ marginBottom: 8, fontSize: 18}}>End of quarantine date:</div>
                        <div class="d">{date}</div>
                    </div>
                }
            </div>
        )
    }
}

export default App;
